<template>
    <div>
        <div class="page-btns-box">
            <el-button
                type="primary"
                icon="el-icon-circle-plus-outline"
                @click="$router.push({name: 'addLogistics'})"
                v-if="$utils.have('/logistics/rule/create')"
                size="small"
                >新增规则</el-button
            >
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column label="规则名称" min-width="240">
                    <template slot-scope="scope">
                        {{scope.row.ruleName}}
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" min-width="120">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            v-if="$utils.have('/logistics/rule/detail')"
                            icon="el-icon-edit"
                            @click="$router.push({name: 'editLogistics', params: {id: scope.row.id}})"
                            >编辑</el-button>
                        <el-button
                            type="text"
                            size="small"
                            v-if="$utils.have('/logistics/rule/updateStatus')"
                            icon="el-icon-delete"
                            @click="delRule(scope.row.id)"
                            >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0"
            >
            </el-pagination>
        </div>
    </div>
</template>
<script>

export default {
    data() {
        return {
            data: null,
            dataList: null,
            params: {
                pageNo: 1,
                pageSize: this.$pageSizes[0]
            },
            detailData: null,
            listLoading: true
        };
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/logistics/rule/list",
                method: "POST",
                data: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        // 删除
        delRule(id){
            this.$confirm('确认删除此规则吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true,
                closeOnClickModal: false
                }).then(() => {
                    this.$request({
                        url: "/logistics/rule/updateStatus",
                        method: "POST",
                        params: {id, status: 0},
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$message.success('删除成功');
                                this.getDataList();
                            } else {
                                this.$message.error(msg || "请求失败");
                            }
                        })
                        .catch(() => {
                            this.$message.error("请求错误");
                        })
                }).catch(() => {});
        }
    },
};
</script>

<style lang="scss" scoped>

</style>